export default "__VITE_ASSET__BeetoKJC__"